import { render } from "./MapEditBasicInfo.vue?vue&type=template&id=6d67fb58&scoped=true&bindings={\"modelValue\":\"props\",\"useCurrentBtnDisabled\":\"props\",\"mapData\":\"options\",\"useCurrentLocationAndZoom\":\"options\",\"openMapEmbedCode\":\"options\",\"openMapEditBounds\":\"options\"}"
import script from "./MapEditBasicInfo.vue?vue&type=script&lang=js"
export * from "./MapEditBasicInfo.vue?vue&type=script&lang=js"

import "./MapEditBasicInfo.vue?vue&type=style&index=0&id=6d67fb58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d67fb58"

export default script